import { AppSettings } from '../app.settings';
import { InboundScreenFiltersDataModel } from './inbound-screen-filters-data-model';

export class InboundScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  /** Filters are saved per user + screen + event; the backend rejects a save without it. */
  eventId?: String;
  filterData: InboundScreenFiltersDataModel = new InboundScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    eventId?: String,
    filterData: InboundScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.eventId = options.eventId;
      this.filterData = options.filterData;
    }
  }
};
